import React, { useEffect, useState } from 'react';
import './landingPageStyle.css';
import { FaShieldAlt, FaMobileAlt, FaGlobeAfrica, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import ParticlesBg from './ParticlesBg';
import clbs from './landing-images/clbs.jpg';
import secureme from '../../../assets/images/new-securemepp-logo.jpeg';
import ogaApp from '../../../assets/images/new-ogaapp-logo.jpeg';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LandingHeader from './landing-header/LandingHeader';

const LandingPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <LandingHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      {/* Hero section temporarily hidden so Our Solutions becomes the focus.
      <section className="hero" id="hero">
        <div className="hero-overlay" />
        <div className="hero-content" data-aos="fade-up">
          <span className="hero-badge">Vitel Wireless: Everything connected</span>
          <h1 className="hero-title">
            <span className="hero-title-highlight">VITEL WIRELESS</span> LIMITED
          </h1>
          <p className="hero-subtitle">
            Unifying communication using GSM Numbers + VoIP + IoT + VAS
          </p>
           <div className="hero-actions">
              <a href="/oga-app/register" className="btn-primary" aria-label="Sign up for OgaApp">
                Sign Up for OgaApp <FaArrowRight className="btn-icon" />
              </a>
              <a href="#services" className="btn-outline">
                Get Started
              </a>
              <a href="#coverage" className="btn-outline">
                Learn More
              </a>
            </div>
            <div className="hero-promise" aria-label="Platform capabilities">
              <span>GSM Numbers</span>
              <span>VoIP</span>
              <span>IoT</span>
              <span>VAS</span>
            </div>

        </div>
        <div className="hero-scroll" data-aos="fade-down" data-aos-delay="500">
          <span className="scroll-text">Scroll</span>
          <IoIosArrowRoundDown className="scroll-arrow" />
        </div>
      </section>
      */}

      <section className="services" id="services">
        <ParticlesBg tone="dark" />
        <div className="container services-inner">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag section-tag-gold">Vitel Wireless · Our Solutions</span>
            <h2 className="section-title">One platform. Three powerful products.</h2>
            <span className="services-divider" aria-hidden="true" />
            <p className="section-desc">
              Enterprise-grade communication, workforce and location
              intelligence — trusted by businesses across Nigeria.
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card shade-sky" data-aos="fade-up" data-aos-delay="0">
              <span className="service-index" aria-hidden="true">01</span>
              <div className="service-img-wrapper">
                <img src={secureme} alt="Secure Me" />
              </div>
              <div className="service-body">
                <span className="service-eyebrow">Personal safety</span>
                <h3 className="service-name">Secure Me</h3>
                <p className="service-desc">
                  Family and employee safety with SOS alerts and live
                  location when it matters most.
                </p>
                <div className="service-actions">
                  <a href="/secureme-app" className="service-btn-primary">
                    Sign In <FaArrowRight className="cta-icon" />
                  </a>
                  <a href="/secureme-app" className="service-cta">
                    Explore <FaArrowRight className="cta-icon" />
                  </a>
                </div>
              </div>
            </div>

            <div className="service-card service-card-featured shade-royal" data-aos="fade-up" data-aos-delay="150">
              <span className="service-flag">Flagship</span>
              <span className="service-index" aria-hidden="true">02</span>
              <div className="service-img-wrapper">
                <img src={ogaApp} alt="OgaApp" />
              </div>
              <div className="service-body">
                <span className="service-eyebrow">Business operations</span>
                <h3 className="service-name">OgaApp</h3>
                <p className="service-desc">
                  Workforce management, device tracking and business
                  communication in one place.
                </p>
                <div className="service-actions">
                  <a href="/oga-app" className="service-btn-primary">
                    Sign In <FaArrowRight className="cta-icon" />
                  </a>
                  <a href="/oga-app/register" className="service-cta">
                    Create account <FaArrowRight className="cta-icon" />
                  </a>
                </div>
              </div>
            </div>

            <div className="service-card shade-navy" data-aos="fade-up" data-aos-delay="300">
              <span className="service-index" aria-hidden="true">03</span>
              <div className="service-img-wrapper">
                <img src={clbs} alt="CLBS" />
              </div>
              <div className="service-body">
                <span className="service-eyebrow">Location intelligence</span>
                <h3 className="service-name">CLBS</h3>
                <p className="service-desc">
                  Carrier-grade location services for accurate
                  positioning and navigation.
                </p>
                <div className="service-actions">
                  <a href="/login" className="service-btn-primary">
                    Sign In <FaArrowRight className="cta-icon" />
                  </a>
                  <a href="/login" className="service-cta">
                    Explore <FaArrowRight className="cta-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="coverage" id="coverage">
        <div className="container">
          <div className="coverage-card" data-aos="fade-up">
            <div className="coverage-copy">
              <span className="section-tag section-tag-light">One connected ecosystem</span>
              <h2>Communication, tracking, and operations—together.</h2>
              <p>
                Give your team one dependable platform to connect with customers,
                protect your people, and keep your business moving.
              </p>
            </div>
            <a href="/oga-app/register" className="coverage-button">
              Start with OgaApp <FaArrowRight className="btn-icon" />
            </a>
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <div className="section-header section-header-dark" data-aos="fade-up">
            <span className="section-tag section-tag-gold">Why Vitel Wireless</span>
            <h2 className="section-title">Built for reliability</h2>
            <span className="services-divider" aria-hidden="true" />
            <p className="section-desc">
              Carrier-grade infrastructure, enterprise security and
              support that never sleeps.
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-item" data-aos="fade-up" data-aos-delay="0">
              <div className="feature-icon"><FaGlobeAfrica /></div>
              <h4>Nationwide Coverage</h4>
              <p>Reliable connectivity across all regions with our robust infrastructure.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="100">
              <div className="feature-icon"><FaShieldAlt /></div>
              <h4>Enterprise Security</h4>
              <p>Bank-grade encryption and security protocols to keep your data safe.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="200">
              <div className="feature-icon"><FaMobileAlt /></div>
              <h4>Real-Time Tracking</h4>
              <p>Live device tracking and monitoring with instant alerts and reporting.</p>
            </div>
            <div className="feature-item" data-aos="fade-up" data-aos-delay="300">
              <div className="feature-icon"><FaCheckCircle /></div>
              <h4>24/7 Support</h4>
              <p>Dedicated support team available around the clock to assist you.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <h3>Vitel Wireless</h3>
              <p>Unifying communication using GSM Numbers + VoIP + IoT + VAS</p>
            </div>
            <nav className="footer-links" aria-label="Products">
              <span className="footer-heading">Products</span>
              <a href="/secureme-app">Secure Me — Sign In</a>
              <a href="/oga-app">OgaApp — Sign In</a>
              <a href="/login">CLBS — Sign In</a>
              <a href="/oga-app/register">Create OgaApp account</a>
            </nav>
            <div className="footer-contact">
              <span className="footer-heading">Support</span>
              <p>For support and enquiries, call</p>
              <a href="tel:2347120000071" className="footer-phone">2347120000071</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Vitel Wireless Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingPage;
